import axios from 'axios';

const mine = (data) => axios.get('/custom/position/mine', data);
const save = (data) => axios.post('/custom/position/saveOrUpdate', data);
const del = (data) => axios.post('/custom/position/delete', data); //delete

export default {
  mine,
  save,
  del,
}


